import {useEffect} from "react";
import SetupApi from "../../../../common/api/functions/Setup";
import {
    seedCommonDefaultsToFormik,
    setCommonDefaultOptionsCache,
} from "../helpers/commonDefaults";

/**
 * When Invoice is not in the wizard (payment/subscription only), still seed
 * Common defaults so setupCompleteness / sync stay healthy.
 */
export const useSeedCommonDefaults = (formik: any): void => {
    useEffect(() => {
        let cancelled = false;
        const needsSeed = [
            'economic_customer_group_number',
            'economic_customer_payment_terms_number',
            'economic_product_group_number',
        ].some((key) => formik.values[key] === null || formik.values[key] === undefined || formik.values[key] === '');

        if (!needsSeed) {
            return;
        }

        SetupApi.getDataSetupCommon().then((response: any) => {
            if (cancelled) return;
            const data = response?.data?.data || {};
            const options = {
                customerGroups: data.customerGroups || [],
                paymentTerms: data.paymentTerms || [],
                productGroups: data.productGroups || [],
            };
            setCommonDefaultOptionsCache(options);
            seedCommonDefaultsToFormik(formik, options);
        }).catch(() => {
            // Best-effort; user can finish Common later in Economic settings
        });

        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
